export const DEFAULT_AMOUNT_LIMIT_MIN = 0.01;

/**
 * Calculate the minimum allowed payment amount based on the selected
 * payment detail and its associated payment method limit.
 *
 * Returns DEFAULT_AMOUNT_LIMIT_MIN when any required data is absent.
 */
export const getAmountLimitMin = (paymentDetailId, paymentDetailsItems = [], paymentMethodList = []) => {
    if (!paymentDetailId || !paymentDetailsItems.length || !paymentMethodList.length) {
        return DEFAULT_AMOUNT_LIMIT_MIN;
    }

    const currentPaymentDetail = paymentDetailsItems.find(item => item.id === paymentDetailId);
    if (!currentPaymentDetail) {
        return DEFAULT_AMOUNT_LIMIT_MIN;
    }

    const currentPaymentMethod = paymentMethodList.find(
        item => item.pm_key === currentPaymentDetail.pm_key
    );

    return currentPaymentMethod?.limit || DEFAULT_AMOUNT_LIMIT_MIN;
};

/**
 * Get the default picked currency key from an account join list.
 *
 * Returns the shared cur_key only when all accounts use the same currency
 * (1 account, or exactly 2 accounts with matching cur_key).
 * Returns null otherwise — letting the user pick manually.
 */
export const getDefaultPickedCurrencyKey = (joinList = []) => {
    if (!joinList.length) {
        return null;
    }

    const firstCurKey = joinList[0]?.cur_key;
    const allEqual = joinList.every(item => item?.cur_key === firstCurKey);

    if (joinList.length === 1 || (joinList.length === 2 && allEqual)) {
        return firstCurKey;
    }

    return null;
};
